import * as style from './index.css'
import * as preact from 'preact'

const { h, Component } = preact

interface Props {
  percentFinished: number;
  height: number;
}

interface State {
  height: number;
}

export class Background extends Component<Props, State> {
  dispose: () => void
  elm: HTMLDivElement
  viewport$: any

  constructor() {
    super()
  }

  getOpacity = () => {
    const stopPosition = 0.44
    const opacity = (stopPosition - this.props.percentFinished) / stopPosition

    if (opacity <= 0.05) {
      return 0.05
    }
    return opacity
  }

  render() {
    const inlineStyle = {
      height: `${this.props.height}px`,
      opacity: this.getOpacity()
    }
    return (
      <div class={style.header__img} style={inlineStyle}>
        <picture>
          <source
            media="(orientation: portrait)"
            srcset="https://static.nrk.no/dh/module/stille-spesial/assets/Header/portrait/bg-768.jpg 768w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/portrait/bg-375.jpg 375w"
          />
          <source
            media="(orientation: landscape)"
            srcset="https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1920.jpg 1920w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1280.jpg 1280w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1024.jpg 1024w, https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-900.jpg 900w,"
          />
          <img
            alt=""
            className={style['header__bg-img']}
            src="https://static.nrk.no/dh/module/stille-spesial/assets/Header/landscape/bg-1024.jpg"
          />
        </picture>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Header/Background/index.tsx